import { useEffect, useRef, useState } from "react";

type UseSyncedDraftDataOptions = {
  savedData: Record<string, unknown>;
  isEditing: boolean;
  isDataLoading?: boolean;
  resetKey: string;
};

export const useSyncedDraftData = ({
  savedData,
  isEditing,
  isDataLoading = false,
  resetKey,
}: UseSyncedDraftDataOptions) => {
  const [draftData, setDraftData] = useState(savedData);
  const draftDataRef = useRef(draftData);
  draftDataRef.current = draftData;
  const wasDataLoadingRef = useRef(isDataLoading);

  useEffect(() => {
    setDraftData(savedData);
    // Reset draft when the persisted record identity changes (e.g. another template/client).
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: only react to resetKey
  }, [resetKey]);

  useEffect(() => {
    const justFinishedLoading = wasDataLoadingRef.current && !isDataLoading;
    wasDataLoadingRef.current = isDataLoading;

    if (!isEditing || isDataLoading || justFinishedLoading) {
      setDraftData(savedData);
    }
  }, [savedData, isEditing, isDataLoading]);

  return {
    draftData,
    setDraftData,
    draftDataRef,
  };
};
